import posthog from 'posthog-js';

/** @type {string | undefined} */
const POSTHOG_API_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

/** @type {string | undefined} */
const POSTHOG_API_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

/**
 * @type {Partial<import('posthog-js').PostHogConfig>}
 */
export const posthogOptions = {
  api_host: POSTHOG_API_HOST,
  defaults: '2025-05-24',
  autocapture: {
    // Only capture interactions with standard interactive elements.
    // Prevents autocapture of text from non-interactive elements (h5, p, div, span)
    // which commonly display patient names, diagnoses, symptoms, and clinical notes.
    element_allowlist: ['a', 'button', 'form', 'input', 'select', 'textarea', 'label'],
  },
  before_send: (event) => {
    if (!event?.properties) {
      return event;
    }

    // External link clicks may expose sensitive URLs (patient documents, eRx scripts)
    // and link text (document names, token numbers). Strip both.
    const withoutExternalUrl = event.properties.$external_click_url
      ? (() => {
          const { $external_click_url: _url, $el_text: _text, ...rest } = event.properties;
          return rest;
        })()
      : event.properties;

    // Strip returnData from orderResponse as it contains sensitive card details
    // (cardholder name, BIN digits, last 4 digits, expiry date)
    // Keep non-sensitive metadata: purchaseId, uuid, success, paymentMethod
    const sanitizedProperties = withoutExternalUrl.orderResponse
      ? (() => {
          const { returnData: _returnData, ...safeOrderResponse } = withoutExternalUrl.orderResponse;
          return { ...withoutExternalUrl, orderResponse: safeOrderResponse };
        })()
      : withoutExternalUrl;

    return { ...event, properties: sanitizedProperties };
  },
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '*',
  },
};

export const initialisePostHog = () => {
  if (!POSTHOG_API_KEY) {
    return;
  }

  posthog.init(POSTHOG_API_KEY, posthogOptions);
};
